import { render, staticRenderFns } from "./ProductTable.vue?vue&type=template&id=3f746cd0&"
import script from "./ProductTable.vue?vue&type=script&lang=ts&"
export * from "./ProductTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTable.vue?vue&type=style&index=0&id=3f746cd0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports